import React from 'react';
import { Redirect as ReactRedirect } from 'react-router';

const Redirect = ({to}) => <ReactRedirect to={to} />;

export default Redirect;